














































































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import { Employer } from "@/admin/types";
import { Location } from "vue-router";
import { InvestmentCustodian, UserPermission, massTransitManualClaimStatusMap } from "@/shared/types";
import { useEmployerStore } from "@/admin/store/employer";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";
import { useEmployerBankSettingsStore } from "@/shared/store/employerBankSettings";
import { massTransitManualClaimStatusIcon } from "@/shared/awesomeIconMapper";

@Component
export default class EmployerNavigation extends Vue {
  @Prop() employerId: number;
  @Prop() activeTab: string;
  @Prop() navigate: (args: {tab: string}) => Location;

  employerStore = useEmployerStore();
  featureFlagStore = useFeatureFlagStore();
  rolePermissionsStore = useRolePermissionsStore();
  employerBankSettingsStore = useEmployerBankSettingsStore();

  created () {
    this.fetchEmployerInvestmentProvider();
  }

  mounted () {
    this.employerBankSettingsStore.getEmployerBankSettings({employerId: this.employerId});
  }

  get employer (): Employer {
    const loadedEmployer = this.employerStore.employerDetail(this.employerId);
    return loadedEmployer.loaded && loadedEmployer.employer;
  }

  get employerName (): string {
    return this.employer ? this.employer.name : "";
  }

  get displayDrivewealthOptions (): boolean {
    const employerOrPartnerThreshold = this.employerStore.investmentThreshold[this.employerId];

    return employerOrPartnerThreshold && employerOrPartnerThreshold.investmentProvider === InvestmentCustodian.Drivewealth;
  }

  @Watch("employerId")
  fetchEmployerInvestmentProvider () {
    this.employerStore.loadEmployerInvestmentThreshold(this.employerId);
  }

  get hasCardSettingsAccess (): boolean {

    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalCardSettingsEdit) ||
      this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalCardSettingsView);
  }

  get showMassTransitSettings (): boolean {
    return this.employerBankSettingsStore.isLoaded
        && this.employerBankSettingsStore.employerHasMassTransitPlan
        && this.rolePermissionsStore.doesUserHavePermission(UserPermission.EmployerPortalMassTransitView);
  }
  get statusIcon () {
    return massTransitManualClaimStatusIcon[this.employerBankSettingsStore.bankSettings.status];
  }
  get statusTitle () {
    return massTransitManualClaimStatusMap[this.employerBankSettingsStore.bankSettings.status];
  }
}
